






















































import {Component, Emit, PropSync} from "vue-property-decorator";
import {PickingList} from "@/interfaces/entity";
import moment from 'moment';
import {PickingListTranshipmentStore} from "@/modules/pickinglisttranshipment";
import PLTranshipmentStatusLabel
    from "@/modules/pickinglisttranshipment/shared/component/PickingListTranshipmentStatusLabel/index.vue";
import {FORMAT_DATE_TIME_PICKER, PAGE_SIZE_OPTIONS} from "@/shared/constant";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";

@Component({
    name: "ConfirmedPLTranshipmentTable",
    components: {TooltipLabel, PLTranshipmentStatusLabel}
})
export default class extends mixins(CommonMixin) {
    @PropSync("dataSource", {required: true}) syncDataSource!: Array<PickingList>;

    moment = moment;
    FORMAT_DATE_TIME_PICKER = FORMAT_DATE_TIME_PICKER;
    columns = [
        {
            title: "Thao tác",
            dataIndex: "id",
            key: "action",
            scopedSlots: {customRender: "action"},
            width: 120,
            fixed: 'left'
        },
        {
            title: "Mã bảng kê",
            dataIndex: "code",
            key: "code",
            width: 130,
            ellipsis: true,
            scopedSlots: {customRender: "code"}
        },
        {
            title: "Ngày dự kiến đến",
            dataIndex: "dateExpectedTo",
            key: "dateExpectedTo",
            scopedSlots: {customRender: "dateExpectedTo"},
            width: 130,
            ellipsis: true
        },
        {
            title: "Tên chuyến thư",
            dataIndex: "name",
            key: "name",
            width: 160,
            ellipsis: true,
            scopedSlots: {customRender: "name"}
        },
        {
            title: "Đối tác vận chuyển",
            dataIndex: "partner.name",
            key: "partnerName",
            width: 160,
            ellipsis: true
        },
        {
            title: "Số kiện",
            dataIndex: "boxQuantity",
            key: "boxQuantity",
            width: 90,
            ellipsis: true
        },
        {
            title: "TL(g)",
            dataIndex: "weight",
            key: "weight",
            width: 100,
            ellipsis: true,
            scopedSlots: {customRender: "weight"}
        },
        {
            title: "Số lượng đơn",
            dataIndex: "ladingQuantity",
            key: "ladingQuantity",
            width: 120,
            ellipsis: true
        },
        {
            title: "Bưu cục gốc",
            dataIndex: "postOfficeFrom.name",
            key: "postOfficeFromName",
            width: 200,
            ellipsis: true,
            scopedSlots: {customRender: "postOfficeFromName"}
        },
        {
            title: "Ngày xác nhận",
            dataIndex: "confirmDate",
            key: "confirmDate",
            scopedSlots: {customRender: "confirmDate"},
            width: 150,
            ellipsis: true
        },
        {
            title: "Số kiện nhận",
            dataIndex: "confirmBoxQuantity",
            key: "confirmBoxQuantity",
            width: 120,
            ellipsis: true
        },
        {
            title: "Đã xác nhận",
            dataIndex: "confirmLadingQuantity",
            key: "confirmLadingQuantity",
            width: 100,
            ellipsis: true
        },
        {
            title: "Thiếu",
            dataIndex: "confirmLadingQuantity",
            key: "remainLadingQuantity",
            scopedSlots: {customRender: "remainLadingQuantity"},
            width: 100,
            ellipsis: true
        },
        {
            title: "Yêu cầu nhờ thu",
            dataIndex: "receiverCollect",
            key: "receiverCollect",
            width: 150,
            ellipsis: true,
            scopedSlots: {customRender: "receiverCollect"}
        },
        {
            title: "XN thu hộ",
            dataIndex: "confirmReceiverCollect",
            key: "confirmReceiverCollect",
            width: 150,
            ellipsis: true,
            scopedSlots: {customRender: 'confirmReceiverCollect'}
        },
        {
            title: "Ghi chú xác nhận",
            dataIndex: "confirmNote",
            key: "confirmNote",
            width: 150,
            ellipsis: true
        },
        {
            title: "GDV xác nhận",
            dataIndex: "confirmEmployee.fullname",
            key: "confirmedEmployee",
            width: 150,
            ellipsis: true,
            scopedSlots: {customRender: "employeeConfirm"}
        },
        {
            title: "Trạng thái",
            dataIndex: "status",
            key: "status",
            scopedSlots: {customRender: "status"},
            width: 200,
            ellipsis: true
        },
    ];
    formatDateTimePicker = FORMAT_DATE_TIME_PICKER;

    get pagination(): object {
        return {
            current: PickingListTranshipmentStore.meta?.page,
            pageSize: PickingListTranshipmentStore.meta?.limit,
            total: PickingListTranshipmentStore.meta?.total,
            showTotal: (total: number) => `Tổng cộng ${total} bảng kê`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    @Emit("onChangePage")
    onChangePage(pagination: any) {
        return pagination;
    }

    @Emit("see-detail")
    seeDetail(id: number) {
        return id;
    }

    @Emit("print")
    print(id: number) {
        return id;
    }
}
